import { API_URL } from '@/constants/config';
import { encodeQuery } from '~/modules/common/utils/routingUtils';

const base = API_URL + '/v3.5';

/**
 * Article Service
 *
 * @param {object} http axios instance from nuxt context
 * @param {object} cookies cookies from nuxt context
 */
export const tagService = (http, cookies) => ({
  /**
   * Get Tag Feed Items
   * @param {string} tagRouteName tag name
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getTagFeed(tagRouteName, page = 1, limit = 26) {
    const useHasNextPage = true;
    const queryParams = encodeQuery({ tagRouteName, limit, page, useHasNextPage, breadcrumb: true });
    const { data, pagination } = await http.$get(`${base}/articles${queryParams}`);
    return { data, pagination };
  },

  /**
   * Get Tag Informations
   * @param {string} tagName tag name
   */
  async getTagInfo(tagName) {
    const { data } = await http.$get(`${base}/tags/route/${tagName}`);
    return { data };
  },

  /**
   * Get Tag Feed Items (Temporary Data NEED UPDATE!)
   * @param {string} tagRouteName tag name
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getTagPopularFeed(tagRouteName, page = 1, limit = 10) {
    const sort = 'agingPopular';
    const useHasNextPage = true;
    const queryParams = encodeQuery({ tagRouteName, limit, page, sort, useHasNextPage, breadcrumb: true });
    const { data } = await http.$get(`${base}/articles${queryParams}`);
    return { data };
  },

  /**
   * Get Random Tag Article Items
   * @param {string} tagId tag id
   * @param {number} [page] page number
   * @param {number} [limit] limit
   */
  async getTagRandomFeed(tagId, page = 1, limit = 10) {
    const sort = 'random';
    const queryParams = encodeQuery({ tagId, limit, page, sort });
    const { data } = await http.$get(`${base}/articles${queryParams}`);
    return { data };
  },
});
